// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/Fonts/N27-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/Fonts/N27-Light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: PP-Nuebit;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: N27;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: N27-Bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: N27-Light;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(54, 54, 54, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    z-index: 1000;
   
  }
  
  .task-overlay-content {
    position: relative;
    width: 90%;
    height: 83%;
    background-color: white;
    padding:2.7% 3.1% 0 3.1%;
    border-top: 1pt solid #151515;
    border-left: 1pt solid #151515;
    border-right: 1pt solid #151515;
  }
  
  
  .close-button {
    position: absolute;
    height: 2.5rem;
    width:2.75rem;
    top: 0;
    right: 0;
    background: #FF3B3B;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }
  .taskoverlay-button-container{
    display: flex;
    height:3.3rem;
    width:90%;
    background-color: white;
    border-top: 1pt solid #9C9C9C;
    border-bottom: 1pt solid #151515;
    border-left: 1pt solid #151515;
    border-right: 1pt solid #151515;
    justify-content: space-between;
    align-items: flex-start;
    padding:1% 3.1% 0 3.1%;
  }
  .discord-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height:2rem;
    width:25.125rem;
  }
  .discord-text-container{
    display: flex;
    height: 95%;
    align-items: center;
    justify-content: flex-start;
  }
  .discord-text{
    font-family: N27;
    font-size: 1.25rem;
    color: black;
    text-align: left;
    margin: 0;
  }
  .discord-button-container{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
  }
  .discord-button{
    height: 100%;
    width:10rem;
    border: none;
    border-radius:3.5px;
    background-color: #5865F2;
    font-family: N27;
    color: white;
    font-size: 1rem;
    text-align: center;
    padding: 1% 1% 1% 1%;
    cursor: pointer;
  }
  .taskSubmit-button-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height:1.5rem;
    /* width: 10rem; */
    padding:0.538rem 1.5rem 0.538rem 1.5rem;
    background-color: #222222;
    cursor: pointer;
  }
  .taskSubmit-button-text{
    font-family:N27-Light;
    font-size: 1.25rem;
    color: white;
    text-align: left;
    letter-spacing: -4%;
    margin: 0;
  }
  .submit-chevron{
    height:1.5rem;
    width: 1rem;
  }
  .task-button-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width:39rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/CourseDescription/Course_Content/TaskScreenOverlay.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,4CAAuD;AACzD;AACA;EACE,gBAAgB;EAChB,4CAAoD;AACtD;AACA;EACE,qBAAqB;EACrB,4CAAiD;AACnD;AACA;EACE,sBAAsB;EACtB,4CAAkD;AACpD;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;EACjC;;;EAGA;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,MAAM;IACN,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;IACb,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,6BAA6B;IAC7B,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;EACb","sourcesContent":["@font-face {\n  font-family: PP-Nuebit;\n  src: url(\"../../../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n@font-face {\n  font-family: N27;\n  src: url(\"../../../../assets/Fonts/N27-Regular.otf\");\n}\n@font-face {\n  font-family: N27-Bold;\n  src: url(\"../../../../assets/Fonts/N27-Bold.otf\");\n}\n@font-face {\n  font-family: N27-Light;\n  src: url(\"../../../../assets/Fonts/N27-Light.otf\");\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(54, 54, 54, 0.8);\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    z-index: 1000;\n   \n  }\n  \n  .task-overlay-content {\n    position: relative;\n    width: 90%;\n    height: 83%;\n    background-color: white;\n    padding:2.7% 3.1% 0 3.1%;\n    border-top: 1pt solid #151515;\n    border-left: 1pt solid #151515;\n    border-right: 1pt solid #151515;\n  }\n  \n  \n  .close-button {\n    position: absolute;\n    height: 2.5rem;\n    width:2.75rem;\n    top: 0;\n    right: 0;\n    background: #FF3B3B;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n  }\n  .taskoverlay-button-container{\n    display: flex;\n    height:3.3rem;\n    width:90%;\n    background-color: white;\n    border-top: 1pt solid #9C9C9C;\n    border-bottom: 1pt solid #151515;\n    border-left: 1pt solid #151515;\n    border-right: 1pt solid #151515;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding:1% 3.1% 0 3.1%;\n  }\n  .discord-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height:2rem;\n    width:25.125rem;\n  }\n  .discord-text-container{\n    display: flex;\n    height: 95%;\n    align-items: center;\n    justify-content: flex-start;\n  }\n  .discord-text{\n    font-family: N27;\n    font-size: 1.25rem;\n    color: black;\n    text-align: left;\n    margin: 0;\n  }\n  .discord-button-container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    height: 100%;\n  }\n  .discord-button{\n    height: 100%;\n    width:10rem;\n    border: none;\n    border-radius:3.5px;\n    background-color: #5865F2;\n    font-family: N27;\n    color: white;\n    font-size: 1rem;\n    text-align: center;\n    padding: 1% 1% 1% 1%;\n    cursor: pointer;\n  }\n  .taskSubmit-button-container{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    height:1.5rem;\n    /* width: 10rem; */\n    padding:0.538rem 1.5rem 0.538rem 1.5rem;\n    background-color: #222222;\n    cursor: pointer;\n  }\n  .taskSubmit-button-text{\n    font-family:N27-Light;\n    font-size: 1.25rem;\n    color: white;\n    text-align: left;\n    letter-spacing: -4%;\n    margin: 0;\n  }\n  .submit-chevron{\n    height:1.5rem;\n    width: 1rem;\n  }\n  .task-button-container{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    width:39rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
